import { render, staticRenderFns } from "./ReviewsTable.vue?vue&type=template&id=f4bc519e&scoped=true&"
import script from "./ReviewsTable.vue?vue&type=script&lang=js&"
export * from "./ReviewsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsTable.vue?vue&type=style&index=0&id=f4bc519e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bc519e",
  null
  
)

export default component.exports